// extracted by css-extract-rspack-plugin
export default {"suggestions":"Suggestions-module__suggestions__wJUlUMk","suggestionButton":"Suggestions-module__suggestionButton__zCYxEKB"};